/**
 * Timeline Day Header Component
 * VOY-12: Day separator in timeline
 */

interface DayHeaderProps {
  label: string;
  isToday?: boolean;
  isTomorrow?: boolean;
}

export function TimelineDayHeader({ label, isToday }: DayHeaderProps) {
  return (
    <div 
      className={`sticky top-24 z-[5] py-3 px-4 border-t-2 backdrop-blur-md ${
        isToday 
          ? 'bg-[#F5F5FF]/90 dark:bg-zinc-800/90 border-[#5B6FED] text-[#5B6FED] dark:text-blue-400' 
          : 'bg-white/60 dark:bg-zinc-900/60 border-gray-300 dark:border-zinc-700 text-gray-700 dark:text-zinc-300'
      }`}
    >
      <h3 className="font-bold text-sm uppercase tracking-wide">
        {label}
      </h3>
    </div>
  );
}

